import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UpcomingLockersComponent from "./UpcomingLockersComponent";
import UserLockersHistoryComponent from "./UserLockersHistoryComponent";

import { 
  getBulkAdvanceBookingAssignLockers, 
  userHistoryLockerDetails
} from "../api/api"; 
import CircularProgressLoader from "./CircularProgressLoader";
import { RenderTabs, getUnitLabelParams } from "../lib/Utils";
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, LS_LOCKER_BANK_INFO } from "../assets/constants/BrowserStorageKeys";

const transformLockerData = (apiData) => {
  if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
    console.error("Invalid API structure:", apiData);
    return [];
  }
  return apiData.data
    .map(locker => ({
      amount: locker.amount,
      assignment: locker.assignment,
      currency: locker.currency,
      locker_bank_name: locker.locker_bank_name,
      order_id: locker.order_id,
      payment_id: locker.payment_id,
      payment_status: locker.payment_status,
      ref_id: locker.ref_id,
      reserve_end: locker.reserve_end,
      reserve_start: locker.reserve_start,
      status: locker.status,
      user: locker.user,
      locker_size: locker.door_size,
      lat:locker?.latitude,
      lng:locker?.longitude,
      BankType:locker?.bank_type,
      LockerBankURL:locker?.location_url,
    }));
};

const transformLockerDataHistory = (data)=>{
  return data.map(
    historyLocker=>({
      amount: historyLocker.total_price,
      assignment: historyLocker.assignment,
      currency: historyLocker.currency,
      locker_bank_name: historyLocker.locker_bank_name,
      order_id: historyLocker.order_id,
      payment_id: historyLocker.payment_id,
      payment_status: historyLocker.payment_status,
      ref_id: historyLocker.ref_id,
      reserve_end: historyLocker.valid_upto,
      reserve_start: historyLocker.assigned_date,
      status: historyLocker.door_status,
      user: historyLocker.username,
      door_number: historyLocker.door_number,
      door_size: historyLocker.door_size,
      reserverType: historyLocker.identifier,
      payment_records:historyLocker?.payment_records,
      BankType:historyLocker?.bank_type,
      BankID:historyLocker?.locker_bank_id,


    })
  )
}

export default function UserLockers({ initialTab, hideUpcomingTab = false }) {
  const { t } = useTranslation();
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);
  const [tabValue, setTabValue] = useState(hideUpcomingTab || initialTab === 'history' ? 1 : 0);
  const activeTab = hideUpcomingTab || tabValue === 1 ? "history" : "upcoming";
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [upcomingLockersData, setUpcomingLockersData] = useState([]);
  const [historyLockersData, setHistoryLockersData] = useState([]);

  useEffect(() => {
    fetchLockerData();
  }, [activeTab]);

  const fetchLockerData = async () => {
    setLoading(true);
    setLoadingMessage(t('msg_fetching_locker_details', unitLabelParams));

    try {
      switch (activeTab) {
        case "upcoming":
          await fetchUpcomingLockers();
          break;

        case "history":
          await fetchHistoryLockers();
          break;

        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching locker data:", error);
      setLoadingMessage(t('msg_failed_to_fetch_data_please_try_again'));
    } finally {
      setLoading(false);
    }
  };

  const fetchUpcomingLockers = async () => {
    try {
      const response = await getBulkAdvanceBookingAssignLockers();
      if (response && response.data?.data) {
        const structuredData = transformLockerData(response.data);
        setUpcomingLockersData(structuredData);
      }
    } catch (error) {
      console.error("Error fetching upcoming lockers:", error);
      setUpcomingLockersData([]);
    }
  };

  const handleUpcomingLockerUpdated = async () => {
    setLoading(true);
    setLoadingMessage(t('pleaseWaitText'));

    try {
      await fetchUpcomingLockers();
    } finally {
      setLoading(false);
    }
  };

  const fetchHistoryLockers = async () => {
    try {
     
      const response = await userHistoryLockerDetails();
      if (response && response.data) {  
        const structuredData = transformLockerDataHistory(response?.data?.data);
        setHistoryLockersData(structuredData);
      }
    } catch (error) {
      console.error("Error fetching history lockers:", error);
      setHistoryLockersData([]);
    }
  };

  const processUpcomingLockers = () => {
  const upcomingLockersList = [];

  if (!Array.isArray(upcomingLockersData)) return upcomingLockersList;

  const formatDateTimeOld = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const datePart = date.toLocaleDateString('en-GB'); 
    const timePart = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return `${datePart} at ${timePart}`;
  };
  const formatDateTime = (dateString) => {
  if (!dateString) return { date: "", time: "" };

  const date = new Date(dateString);
  if (isNaN(date)) return { date: "", time: "" };

  const datePart = date.toLocaleDateString('en-GB'); 
  const timePart = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return {
    date: datePart,
    time: timePart,
  };
};

  upcomingLockersData.forEach((transaction) => {
      if (!transaction) return;
      const reserveStart =
        transaction.reserve_start ?? transaction?.reserve_start;
      const reserveEnd =
        transaction.reserve_end ?? transaction?.reserve_end;
const checkInData = formatDateTime(reserveStart);
const checkOutData = formatDateTime(reserveEnd);
const tempcheckInData = formatDateTimeOld(reserveStart);
const tempcheckOutData = formatDateTimeOld(reserveEnd);

upcomingLockersList.push({
  id: transaction.id || transaction.ref_id,
  name: transaction.assignment_name || transaction?.assignment?.name || "",
  lockerNumber: transaction.door_no || "Not Assigned",
  size:  transaction.locker_size ? `${transaction.locker_size} Size ` :  "Standard",
  locker_bank_name: transaction?.locker_bank_name,
  checkInDate: checkInData.date,
  checkInTime: checkInData.time,
  checkOutDate: checkOutData.date,
  checkOutTime: checkOutData.time,
  checkIn:tempcheckInData,
  checkOut:tempcheckOutData,
  bookingRef: transaction?.ref_id,
  transactionRef: transaction?.ref_id,
  paymentStatus: transaction?.payment_status,
  status: transaction?.status,
  doorId: transaction?.door_no,
  currency: transaction?.currency,
  ref_id: transaction?.ref_id,
  position:{
          lat:transaction?.lat,
          lng:transaction?.lng
        },
  BankType:transaction?.BankType,
  LockerBankURL:transaction?.LockerBankURL,
});
      

    });

  return upcomingLockersList;
};
  const upcomingLockers = upcomingLockersData.length > 0 
    ? processUpcomingLockers() 
    : [];

  const historyLockers = historyLockersData.length > 0 
    ? historyLockersData
    : [];

  return (
    <div className="user-locker-component">
      {!hideUpcomingTab && (
        <RenderTabs
          isFirstTab
          isSecondTab
          FirstTabLabalName="Upcoming"
          SecondTabLabalName="History"
          tabValue={tabValue}
          onChange={setTabValue}
          t={t}
        />
      )}
      {loading ? 
          <div className='loade-container'>
            <CircularProgressLoader message={loadingMessage} />
          </div>
          :
          <div className="tab-content">
            {activeTab === "upcoming" && (
              upcomingLockers.length > 0 ? (
                upcomingLockers.map((locker) => (
                  <UpcomingLockersComponent
                    key={locker.id}
                    locker={locker}
                    onBookingUpdated={handleUpcomingLockerUpdated}
                  />
                ))
              ) : (
                <div className="empty-state">{t("no_upcoming_lockers_found_text", unitLabelParams)}</div>
              )
            )}

            {activeTab === "history" && (
              historyLockers.length > 0 ? (
                historyLockers.map((locker) => (
                  <UserLockersHistoryComponent
                    key={locker.id}
                    locker={locker}
                  />
                ))
              ) : (
                <div className="empty-state">{t("no_history_found_text")}</div>
              )
            )}
          </div>
      }
    </div>
  );
}
